import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '#api/axios';

export default function useDeleteEducationMutation() {
  const queryClient = useQueryClient();
  return useMutation(
    async (educationId: string) => {
      await request({
        method: 'delete',
        url: `/educations/${educationId}`
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['educations']
        });
      }
    }
  );
}
